import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { SessionService } from "@kno2/core/session";

const DESTINATION_LABELS: Record<string, string> = {
    "/intake": "My Intake",
    "/account/dashboard": "Dashboard",
    "/admin/reports": "Reports"
};

@Component({
    selector: "kno2-unauthorized",
    template: `
        <div class="row settings-general">
            <div class="col-sm-12">
                <div class="box-content">
                    <div class="well-lg">
                        <h1>Not Authorized</h1>
                        <p>You don't have access to this page or item.</p>
                        <p>If you followed a link, the item may have been reassigned, processed, or removed since the link was created.</p>
                        @if (hasReachableHome) {
                            <button
                                type="button"
                                class="btn btn-primary"
                                (click)="goHome()">
                                Back to {{ homeLabel }}
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    `
})
export class UnauthorizedComponent {
    private readonly router = inject(Router);
    private readonly sessionService = inject(SessionService);
    private readonly homeRoute = this.sessionService.getDefaultRouteForActiveRole();

    protected readonly homeLabel = DESTINATION_LABELS[this.homeRoute];
    protected readonly hasReachableHome = this.sessionService.userInRole(["Administrator", "User"]) || this.sessionService.isSysAdmin();

    protected goHome(): void {
        this.router.navigateByUrl(this.homeRoute);
    }
}
